import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
export function HeaderBanner() {
  return <div className="w-full py-12 md:py-16 relative overflow-hidden" style={{
    backgroundColor: '#1e3d2f'
  }} data-id="element-3203">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#c8a84b 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-3204" />
      <div className="max-w-4xl mx-auto px-4 md:px-8 relative z-10" data-id="element-3205">
        <div className="flex items-center gap-2 mb-4" data-id="element-3206">
          <Link to="/PhotoTour.html" className="text-xs font-bold uppercase tracking-widest transition-colors hover:text-white" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3207">
            Firearms Education
          </Link>
          <ChevronRightIcon size={12} style={{
          color: '#a0c8b0'
        }} data-id="element-3208" />
          <span className="text-xs font-bold uppercase tracking-widest" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3209">
            Self Defense
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold uppercase" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#ffffff'
      }} data-id="element-3210">
          FLSC Self Defense Class
        </h1>
        <div className="w-16 h-1 mt-6 rounded-full" style={{
        backgroundColor: '#c8a84b'
      }} data-id="element-3211" />
      </div>
    </div>;
}